"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Sensor(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M13.414 10.95a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828m-4.95 5.95a.997.997 0 0 1-.706-.294A5.957 5.957 0 0 1 6 12.364c0-1.603.624-3.11 1.758-4.242a.999.999 0 1 1 1.414 1.414A3.971 3.971 0 0 0 8 12.364c0 1.068.416 2.072 1.172 2.828a.999.999 0 0 1-.707 1.707m7.07 0a.999.999 0 0 1-.707-1.707A3.973 3.973 0 0 0 16 12.364a3.971 3.971 0 0 0-1.172-2.828.999.999 0 1 1 1.414-1.414A5.954 5.954 0 0 1 18 12.364a5.957 5.957 0 0 1-1.758 4.242.997.997 0 0 1-.707.293m2.83 2.83a.999.999 0 0 1-.707-1.707c3.118-3.12 3.118-8.195 0-11.314a1 1 0 1 1 1.413-1.415c3.9 3.9 3.9 10.244 0 14.143a.997.997 0 0 1-.707.293m-12.728 0a.997.997 0 0 1-.707-.293A9.934 9.934 0 0 1 2 12.364a9.936 9.936 0 0 1 2.93-7.072 1.002 1.002 0 0 1 1.414 0 1.004 1.004 0 0 1 0 1.415A7.943 7.943 0 0 0 4 12.364c0 2.136.832 4.146 2.344 5.657a1.001 1.001 0 0 1-.708 1.707", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Sensor;
